module.exports = __webpack_public_path__ + "static/project-website-0af3e0dd78e33c1ddb5f865d4039d520.png";